import React from 'react'

export const TrophyIcon: React.FC<{ color?: string; size?: number }> = ({ color = 'currentColor', size = 24 }) => (
  <svg
    width={size}
    height={size}
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    stroke={color}
    strokeWidth='2'
    strokeLinecap='round'
    strokeLinejoin='round'
  >
    <path d='M12 2v4'></path>
    <path d='M18.6 6.4a5 5 0 0 0-13.2 0'></path>
    <path d='M6 10H4a2 2 0 0 0-2 2v4a2 2 0 0 0 2 2h2'></path>
    <path d='M18 10h2a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2h-2'></path>
    <path d='M12 10v12'></path>
    <path d='M8 22h8'></path>
  </svg>
)
